export default function dedupeByLatLng(markersData) {
    const map = new Map();

    markersData.forEach(marker => {
        const key = `${marker.lat.toFixed(6)}_${marker.lng.toFixed(6)}`;

        if (!map.has(key)) {
            map.set(key, {
                lat: marker.lat,
                lng: marker.lng,
                color: marker.color,
                glyphText: marker.glyphText,
                zIndex: marker.zIndex,
                markers: [marker],
            });
        } else {
            map.get(key).markers.push(marker);
        }


        if(marker.zIndex >= map.get(key).zIndex){
            map.get(key).zIndex = marker.zIndex;
            map.get(key).color = marker.color
        }

    });

    return Array.from(map.values());
}